var _mask, _g, _g2, _path, _g3, _path2, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950122808(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sidesRound-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 16,
    width: 156,
    height: 45
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 38.5,
    rx: 18,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18,
    cy: 22.5,
    rx: 18,
    ry: 22.5,
    transform: "matrix(-1 0 0 1 48 16)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesRound-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M20 0h140v76H20z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "topPyramid-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 8,
    width: 64,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m50 8 32 44H18L50 8Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#topPyramid-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M50 4h30v48H50z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceRound02-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31v-1c.18-.48.4-1.5 1-3 .83-3.06 2.78-6.56 6-10C16.7 6.6 35.17 0 65 0s48.3 6.6 58 17c3.22 3.44 5.17 6.94 6 10 .6 1.5.82 2.52 1 3v40c0-.1-.03.5 0 1a53.93 53.93 0 0 1-1 6c-1.19 6-3.4 11.91-7 17-9.72 16.34-27.74 26-57 26s-47.28-9.66-57-26C4.4 88.91 2.2 83 1 77a53.95 53.95 0 0 1-1-6c.03-.45 0-1.32 0-1V31Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceRound02-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h138v124H-4V-2Z",
    fill: "#fdd835"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 27,
    height: 8,
    rx: 4,
    fill: "#000",
    fillOpacity: 0.8
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 2H8c-4.5 0-8 3.5-8 8.03V28c0 4.5 3.5 8 8 8h13c8 0 11 8 18 8h27c7 0 9-8 17-8h13c4.5 0 8-3.5 8-8V10c0-4.5-3.5-8-8-8Z",
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 14H17c-3.5 0-5 3-5 5v2c0 2 1.5 5 5 5h12c6 0 11.62 8 17 8h14c5.38 0 9-8 15-8h12c3.5 0 5-3 5-5v-2c0-2-1.5-5-5-5Z",
    fill: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 36.09 37.26 2h11L31.4 40.78l-.76-.58c-2.38-1.82-4.83-3.69-8.2-4.11ZM11.48 36 26.26 2h4L15.48 36h-4Z",
    fill: "#fff",
    fillOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950122808);
export default __webpack_public_path__ + "static/media/bottts-1767950122808.b9414570a659eff474ba6546d7bf177b.svg";
export { ForwardRef as ReactComponent };